export function getEnvironment(): "prod" | "dev" {
	const isDevEnvironment =
		window.location.host.startsWith("dev.") ||
		window.location.hostname === "localhost" ||
		(window as any).Cypress;
	const isProductionVersion = import.meta.env.PROD;

	let environment: "prod" | "dev" = "dev";
	if (!isDevEnvironment && isProductionVersion) {
		environment = "prod";
	}
	return environment;
}
